import styled from '@emotion/styled';

export const SadaApply = styled.div`
  height: 100vh;
`;
